export default __webpack_public_path__ + "static/media/GLP.087335c1.svg";